export default __webpack_public_path__ + "static/media/no-phone.73ed4a83.svg";